import {
  Cable, Radio, Satellite, Globe, Network, ShieldCheck, HardHat, Lock,
  Home, Building2, RadioTower, Landmark, Building, Store, LucideIcon,
} from "lucide-react";

const MAP = { Cable, Radio, Satellite, Globe, Network, ShieldCheck, HardHat, Lock, Home, Building2, RadioTower, Tower: RadioTower, Landmark, Building, Store };

export const IconByName = ({ name, size = 22, className = "" }) => {
  const Icon = MAP[name] || Globe;
  return <Icon size={size} className={className} aria-hidden="true" />;
};
